import Icon from "@chakra-ui/icon"
import { Box, Flex, Heading, Stack } from "@chakra-ui/layout"
import React, { useState } from "react"
import PensilLeftIcon from "../../assets/pencil-left.svg"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import styled from "styled-components"
import { Img } from "@chakra-ui/image"
import BigPlayIcon from "../../assets/big-play-icon.svg"
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay } from "@chakra-ui/modal"
import ReactPlayer from "react-player"
import { useDisclosure } from "@chakra-ui/hooks"

const content = [
    {
        img: "https://img.youtube.com/vi/5N52dqSMPh8/mqdefault.jpg",
        video: "5N52dqSMPh8",
        title: "Дигиталне учионице",
    },
    {
        img: "https://img.youtube.com/vi/2_2bSZFR8Ms/mqdefault.jpg",
        video: "2_2bSZFR8Ms",
        title: "Дуално образовање",
    },
    {
        img: "https://img.youtube.com/vi/L3uZtNQqzB0/mqdefault.jpg",
        video: "L3uZtNQqzB0",
        title: "Обнова",
    },
    {
        img: "https://img.youtube.com/vi/rlkse9SZFag/mqdefault.jpg",
        video: "rlkse9SZFag",
        title: "Обуке",
    },
    {
        img: "https://img.youtube.com/vi/4VhLNxdhAfI/mqdefault.jpg",
        video: "4VhLNxdhAfI",
        title: "Студенти",
    },
    {
        img: "https://img.youtube.com/vi/WqUBUL3cBAo/mqdefault.jpg",
        video: "WqUBUL3cBAo",
        title: "Инклузија мањине",
    },
    {
        img: "https://img.youtube.com/vi/ez4dVV01lSE/mqdefault.jpg",
        video: "ez4dVV01lSE",
        title: "Национални оквир квалификација",
    },
    {
        img: "https://img.youtube.com/vi/_k2ESqMeebg/mqdefault.jpg",
        video: "_k2ESqMeebg",
        title: "Дуално образовање",
    },
    {
        img: "https://img.youtube.com/vi/8nP8pJwGfiE/mqdefault.jpg",
        video: "8nP8pJwGfiE",
        title: "Предшколско",
    },
    {
        img: "https://img.youtube.com/vi/cJASQfhBVtw/mqdefault.jpg",
        video: "cJASQfhBVtw",
        title: "Обнова",
    },
    {
        img: "https://img.youtube.com/vi/aSgnQa9srYA/mqdefault.jpg",
        video: "aSgnQa9srYA",
        title: "Дигиталне учионице",
    },
    {
        img: "https://img.youtube.com/vi/1IDAubGzQDI/mqdefault.jpg",
        video: "1IDAubGzQDI",
        title: "Инклузија Асистенти",
    },
    {
        img: "https://img.youtube.com/vi/3GOH61Alqc4/mqdefault.jpg",
        video: "3GOH61Alqc4",
        title: "Инклузија",
    },
]

const ShortVideos = () => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [tempId, setTempId] = useState("0")

    const settings = {
        dots: true,
        // autoplay: true,
        // autoplaySpeed: 5000,
        slidesToShow: 4,
        slidesToScroll: 4,
        // className: "center",
        // centerMode: true,
        infinite: true,
        // centerPadding: "0",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    // initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                },
            },
        ],
    }
    console.log(content[1].video)

    return (
        <Stack
            bg="_olive"
            w="100%"
            h={["380px", "467px"]}
            py={["20px", "20px", "20px", "60px"]}
            mt={["30px", "50px", "60px", "120px"]}
            align="center"
        >
            <Flex w="100%" justify={["flex-start", "space-between"]} direction={["column", "row"]}>
                <Box
                    transform={[
                        "translate(0, -34px)",
                        "translate(0, -88px)",
                        "translate(0, -88px)",
                        "translate(0, -128px)",
                    ]}
                >
                    <Icon as={PensilLeftIcon} w={["40%", "100%"]} h={["100%", "138px"]} />
                </Box>

                <Heading
                    pr={["10px", "40px", "40px", "40px", "140px"]}
                    color="#fff"
                    fontSize={["24px", "32px", "38px", "54px", "72px"]}
                    textTransform="uppercase"
                    whiteSpace={["normal", "normal", "nowrap"]}
                    textAlign="center"
                >
                    Заједно за образовање
                </Heading>
            </Flex>
            <SliderBox>
                <Slider {...settings}>
                    {content.map((slide, i) => {
                        return (
                            <Flex
                                key={i}
                                w={["340px", "340px", "400px"]}
                                h={["200px"]}
                                onClick={() => {
                                    setTempId(i)
                                    onOpen()
                                }}
                                pos="relative"
                                cursor="pointer"
                                title={slide.title}
                            >
                                <Flex
                                    pos="absolute"
                                    top="0"
                                    left="0"
                                    w="100%"
                                    h="200px"
                                    justify="center"
                                    align="center"
                                >
                                    <Icon as={BigPlayIcon} w="59px" h="54px" />
                                </Flex>
                                <Img
                                    src={slide.img}
                                    objectFit="cover"
                                    objectPosition="top"
                                    _hover={{
                                        cursor: "pointer",
                                    }}
                                />
                            </Flex>
                        )
                    })}
                </Slider>
            </SliderBox>
            <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
                <ModalOverlay bg="rgba(23, 18, 10, 0.85)" />
                <ModalContent>
                    <ModalCloseButton top="-10" bg="#fff" _hover={{ bg: "#fff" }} />
                    <ModalBody pt="56.25%">
                        {/* Video... */}
                        <ReactPlayer
                            url={`https://youtu.be/${content[tempId].video}`}
                            style={{
                                position: "absolute",
                                top: "0",
                                left: "0",
                            }}
                            width="100%"
                            height="100%"
                            controls
                            playing
                            config={{
                                youtube: {
                                    preload: true,
                                },
                            }}
                        />
                    </ModalBody>
                </ModalContent>
            </Modal>
        </Stack>
    )
}

const SliderBox = styled.div`
    background: #7a7e67;
    width: 1200px;

    padding: 12px;
    .slick-slider {
        height: 200px;
    }

    .slick-slide {
        height: 100%;
        height: 200px;
        border: 4px solid #7a7e67;
        box-sizing: border-box;
    }

    .slick-list {
        /* pointer-events: none; */
    }
    .slick-slide img {
        height: 100%;
        width: 100%;
        border: 2.5px solid white;
        box-sizing: border-box;
        :hover {
            border: 4.5px solid white;
            transition: 0.5ms;
        }
    }

    .slick-dots {
        height: 60px;
        bottom: -60px;
    }

    @media (max-width: 480px) {
        .slick-dots {
            /* padding: 0 10px; */

            /* left: -60px; */
            /* width: 120%; */
            width: 86vw;
            transform: translate(-30px, 0);
            li {
                width: 16px;
                margin: 0 3px;
            }
        }
    }
    @media (max-width: 1024px) {
        .slick-slider {
            height: 100%;
        }
    }
    @media (max-width: 1290px) {
        width: 80%;
    }
`

export default ShortVideos
